// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1Mg72","inputWrap":"CustomTip_inputWrap__H2DyF"};